import React from "react";

export function LocationPinIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="travel-map-location-pin--navigation-map-maps-pin-gps-location--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M13.1426 6.71429C13.1426 9.56 7.99979 16.4286 7.99979 16.4286C7.99979 16.4286 2.85693 9.56 2.85693 6.71429C2.85693 5.35032 3.39877 4.04221 4.36324 3.07774C5.32771 2.11326 6.63582 1.57143 7.99979 1.57143C9.36376 1.57143 10.6719 2.11326 11.6363 3.07774C12.6008 4.04221 13.1426 5.35032 13.1426 6.71429V6.71429Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M7.99993 8.42857C8.9467 8.42857 9.71422 7.66106 9.71422 6.71429C9.71422 5.76751 8.9467 5 7.99993 5C7.05316 5 6.28564 5.76751 6.28564 6.71429C6.28564 7.66106 7.05316 8.42857 7.99993 8.42857Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
